import { useNavigate } from 'react-router-dom';
import BackButton from 'app/components/Header/BackButton';
import CloseButton from 'app/components/Header/CloseButton';
import { cx } from '@twind/core';
import useHistory from 'app/modules/tailor/hooks/useHistory';
import useLandingRoute from 'app/hooks/useLandingRoute';
import { useTailorIsOpen } from 'app/hooks/useTailorIsOpen';

import ConciergeInfo from './ConciergeInfo';
import PhoneButton from './PhoneButton';
import useLiveChatTracking from '../../hooks/useLiveChatTracking';

type Props = {
  showBackButton: boolean;
};

const LiveChatHeader = ({ showBackButton = true }: Props) => {
  const navigate = useNavigate();
  const { setIsOpen } = useTailorIsOpen();
  const { location } = useHistory();
  const landingRoute = useLandingRoute();
  const { captureCallButtonClicked, captureMinimized, captureBackButtonClicked } = useLiveChatTracking();

  const onClickBack = () => {
    const options = { state: { isBack: true } };

    const from = location?.state?.from;

    if (from) {
      navigate(from, options);
    } else {
      navigate(landingRoute, options);
    }

    captureBackButtonClicked();
  };

  const handleCollapse = () => {
    setIsOpen(false);
    captureMinimized();
  };

  const handlePhoneClick = () => {
    captureCallButtonClicked();
  };

  return (
    <div className="flex shrink-0 shadow py-2 pl-4 pr-5 z-10">
      <BackButton
        className={cx('w-[32px] p-0', { invisible: !showBackButton })}
        onClick={onClickBack}
        label=""
      />
      <ConciergeInfo />
      <PhoneButton onClick={handlePhoneClick} />
      <CloseButton
        className="w-[32px]"
        onClick={handleCollapse}
      />
    </div>
  );
};

export default LiveChatHeader;
